import { type PropsWithChildren } from 'react';

/**
 * @public
 */
export type SelectCustomTriggerProps = PropsWithChildren;

/**
 * @public
 */
export function SelectCustomTrigger(props: SelectCustomTriggerProps): null {
  return null;
}
